<template>
<el-collapse-item :name="infoObj.build" class="build_box">
  <div slot="title" class="build_header">
    <!-- <el-checkbox
      :indeterminate="infoObj.isIndeterminate"
      v-model="infoObj.checked"
      @change="handleCheckBuild">
      {{infoObj.build}}
    </el-checkbox> -->
    <div>{{infoObj.build}}</div>
    <div class="num_checked">
      已选屏幕：
      <span class="checked">{{totalCheckedDevice.length}}</span>
      <span class="device_all">/{{totalDeviceCount}}</span>
    </div>
  </div>
  <!-- 单元list -->
  <MonitUnit
    v-for="(unitItem, i) in infoObj.value"
    :key="unitItem.unit + '__' + i"
    :transport.sync="unitItem"
    @check-change="checkChange">
  </MonitUnit>
</el-collapse-item>
</template>

<script>
import ListMixin from './mixin/ListMixin'
import MonitUnit from './MonitUnit'

export default {
  name: 'MonitBuild',
  components: { MonitUnit },
  mixins: [ ListMixin ],
  props: {
    // transport: {
    //   type: Object,
    //   default () {
    //     return {
    //       build: '', //楼幢名
    //       value: []   //单元列表
    //     }
    //   }
    // }
  },
  data () {
    return {
      elIdsBuild: [], //当前楼幢已勾选的电梯id
    }
  },
  destroyed () {
    this.infoObj = null
  },
  methods: {
    handleCheckBuild (val) {
      console.log('勾选楼幢:' + this.infoObj.build, val)
      this.changeItemStatus(this.infoObj, val)
      this.$emit('check-change')
    }
  }
}
</script>

<style lang="scss" scoped>
.build_box {
  background: #f5f5f5;
  margin-bottom: 10px;
}
.build_header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 0 10px;
  .num_checked {
    color: #999;
    .checked {
      color: #FF3973;
    }
    .device_all {
      color: #282729;
    }
  }
}
</style>
